module.exports = __webpack_public_path__ + "img/home1.8db1079a.svg";